var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _c(
      "div",
      { staticStyle: { padding: "5px 0" } },
      [
        _c(
          "el-button",
          {
            attrs: { no: "1", type: "primary", disabled: !_vm.isEdit },
            on: { click: _vm.addPassengerHandler }
          },
          [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
        ),
        _c(
          "el-button",
          {
            attrs: { no: "2", type: "danger", disabled: !_vm.isEdit },
            on: { click: _vm.removePassengerHandler }
          },
          [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "section grid-wrapper", staticStyle: { height: "450px" } },
      [
        _c("cargo-ag-grid", {
          staticStyle: { width: "100%" },
          attrs: {
            "grid-options": _vm.gridOptions,
            "column-defs": _vm.columnDefs,
            "row-data": _vm.rowData
          },
          on: {
            gridReady: function(params) {
              _vm.gridApi = params.api
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }